import { defineStyleConfig as c } from "@chakra-ui/react";
import { ThemeFontSizeToken as s, ThemeFontToken as m, ThemeSpaceToken as d, ThemeRadiusToken as S, ThemeColorToken as t } from "../theme-tokens.js";
const l = ["Primary", "Secondary", "Success", "Error", "Info", "Neutral", "Warning"], f = l.reduce(
  (n, o) => {
    const e = n, r = `${o.toLowerCase()}Solid`, a = o, i = `On${o}`;
    return e[r] = {
      backgroundColor: t[a],
      textColor: t[i]
    }, e;
  },
  {}
), u = l.reduce(
  (n, o) => {
    const e = n, r = `${o.toLowerCase()}`, a = `${o}Container`, i = `On${o}Container`;
    return e[r] = {
      backgroundColor: t[a],
      textColor: t[i]
    }, e;
  },
  {}
), C = {
  borderRadius: S.Small,
  display: "flex",
  alignItems: "center",
  px: d.XSmall,
  height: "24px",
  textTransform: "none",
  width: "fit-content",
  fontFamily: m.Body,
  fontWeight: 500
}, h = c({
  baseStyle: C,
  sizes: {
    md: {
      fontSize: s.Small
    },
    sm: {
      fontSize: s.XSmall
    }
  },
  defaultProps: {
    size: "md",
    variant: "neutral"
  },
  variants: {
    ...f,
    ...u
  }
});
export {
  h as badgeConfig
};
